module.exports = __webpack_public_path__ + "b51f491ff25bf4dafd8f5ba8fe0b1f91.svg";